import { Role } from '../../enums';
import { IUserData } from './UserDataClient';

export const getUserImage = (user: IUserData) => {
    if (user.picture) {
        return 'data:image;base64, ' + user.picture.toString();
    }
    return undefined;
}

export const getUserRoleTranslationKey = (role: Role): string => {
    switch (role) {
        case Role.PRIMARY_USER:
            return 'weconnect.userlist.tile.overlay.table.mainUser';
        case Role.SECONDARY_USER:
            return 'weconnect.userlist.tile.overlay.table.secondaryUser';
        case Role.GUEST_USER:
            return 'weconnect.userlist.tile.overlay.table.guestUser';
        default:
            return '';
    }

}